/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, July 2023
 * @flow
 */

import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  IconButton,
  Icon,
  Button
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import useStyles from '../../../../components/Sms/useStyles';
import labels from '../../labels';
import cn from 'classnames';

const SmsSuccess = ({
  open,
  onClose,
  success,
  retry,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      PaperProps={{
        style: {
          minHeight: '60%',
          minWidth: '70%',
        }
      }}
    >
      <DialogTitle id="dialog-title" className={classes.dialogTitleContainer} disableTypography>
        <Typography variant="body1" className={classes.dialogTitle}>{'Sms'}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} padding={1} marginTop={10}>
          <Icon className={cn('material-icons', success ? classes.successIcon : classes.errorIcon)} fontSize={'large'}>{success ? 'check_circle' : 'highlight_off'}</Icon>
          <Typography variant='h6' className={success ? classes.smsSuccess : classes.smsError}>{success ? labels.SMS_SUCCESS : labels.SMS_ERROR}</Typography>
          <Typography variant='subtitle2' className={success ? classes.smsSuccess : classes.smsError}>{success ? labels.SMS_SUCCESS_MESSAGE : labels.SMS_ERROR_MESSAGE}</Typography>
        </Box>
      </DialogContent>
      <Button
        variant="contained"
        color="primary"
        onClick={success ? onClose : retry}
        className={success ? classes.smsSuccessButton : classes.smsErrorButton}
      >
        {success ? labels.SMS_OK : labels.SMS_TRY_AGAIN}
      </Button>
    </Dialog>
  );
};

export default SmsSuccess;
